// Business-focused routing configuration
// The garage/lot metaphor is purely for UI organization, not URL structure

import { GARAGES } from '../constants/garages.js';

// REMOVED: CLIENT_PORTAL_VEHICLES - Use /portal/* routes instead (public client portal)

export const BUSINESS_ROUTES = {
  // Home - Direct to Assignments (MVP focus)
  '/': {
    garageId: 'operations',
    lotId: 'assignments',
    title: 'Assignments',
    brickId: 'assignments'
  },

  // Operations domain
  '/assignments': {
    garageId: 'operations',
    lotId: 'assignments',
    title: 'Assignments',
    brickId: 'assignments'
  },
  '/operations/assignments': {
    garageId: 'operations',
    lotId: 'assignments',
    title: 'Assignment, Management',
    brickId: 'assignments'
  },
  '/assignments/calendar': {
    garageId: 'operations',
    lotId: 'calendar',
    title: 'Assignment, Calendar',
    brickId: 'assignments'
  },
  '/scheduler': {
    garageId: 'operations',
    lotId: 'scheduler',
    title: 'Scheduler',
    brickId: 'scheduler'
  },
  '/events': {
    garageId: 'operations',
    lotId: 'events',
    title: 'Events',
    brickId: 'events'
  },
  '/operations/products': {
    garageId: 'operations',
    lotId: 'products',
    title: 'Products & Services',
    brickId: 'products'
  },
  '/locations': {
    garageId: 'operations',
    lotId: 'locations',
    title: 'Locations',
    brickId: 'locations'
  },
  // ODV Living Brain Map — interactive neuro-map graph (bricksOS/observation nodes)
  '/operations/brain': {
    garageId: 'operations',
    lotId: 'brain',
    vehicleName: 'BrainMap',
    title: 'ODV Brain',
    brickId: 'operations'
  },
  '/brain': {
    garageId: 'operations',
    lotId: 'brain',
    vehicleName: 'BrainMap',
    title: 'ODV Brain',
    brickId: 'operations'
  },
  '/operations/services': {
    garageId: 'operations',
    lotId: 'assignments',
    vehicleName: 'ServiceDashboard',
    title: 'Service, Fulfillment',
    brickId: 'assignments'
  },

  // Finance domain
  '/finance': {
    garageId: 'finance',
    lotId: 'finance',
    vehicleName: 'FinanceHub',
    title: 'Finance',
    brickId: 'finance'
  },
  '/finance/dashboard': {
    garageId: 'finance',
    lotId: 'dashboard',
    vehicleName: 'FinanceDashboardEnhanced',
    title: 'Finance, Dashboard',
    brickId: 'finance'
  },
  '/finance/bookkeeping': {
    garageId: 'finance',
    lotId: 'bookkeeping',
    vehicleName: 'BookkeepingLot',
    title: 'Books',
    brickId: 'finance'
  },
  '/finance/garage': {
    garageId: 'finance',
    lotId: 'bookkeeping',
    vehicleName: 'BookkeepingLot',
    title: 'Books',
    brickId: 'finance'
  },
  '/finance/payouts': {
    garageId: 'finance',
    lotId: 'disbursements',
    vehicleName: 'DisbursementsWithTabs',
    title: 'Payouts',
    brickId: 'disbursements'
  },
  '/finance/invoices': {
    garageId: 'finance',
    lotId: 'invoices',
    vehicleName: 'InvoiceDashboard',
    title: 'Invoices',
    brickId: 'finance'
  },
  '/finance/invoice-builder': {
    garageId: 'finance',
    lotId: 'invoices',
    // Retired compatibility alias. Old bookmarks land on the canonical invoice
    // dashboard instead of mounting the legacy direct-write builder.
    vehicleName: 'InvoiceDashboard',
    title: 'Invoices',
    brickId: 'finance'
  },
  '/finance/collections': {
    garageId: 'finance',
    lotId: 'collections',
    vehicleName: 'CollectionsDashboard',
    title: 'Collections',
    brickId: 'finance'
  },
  '/finance/tax-tracking': {
    garageId: 'finance',
    lotId: 'tax-tracking',
    vehicleName: 'TaxTrackingDashboard',
    title: 'Tax Tracking',
    brickId: 'finance'
  },
  '/clients/portal-readiness': {
    garageId: 'clients',
    lotId: 'clients',
    vehicleName: 'PortalReadinessTracker',
    title: 'Portal Readiness',
    brickId: 'clients'
  },

  // Consolidated invoice routes - all use InvoiceDashboard with tab support
  '/finance/breaking-bread': {
    garageId: 'finance',
    lotId: 'breaking-bread',
    vehicleName: 'BreakingBread',
    title: "Breakin' Bread",
    brickId: 'finance'
  },
  // Retired 2026-10-19 (Doug: "yes retire orchard"). Orchard's Send duplicated the Invoices page
  // and its leaderboard was a second revenue-minus-labor with a Sunday-start week. Old links land
  // on Finance, where net per account (finance.pnl_lines) is the one definition.
  '/finance/orchard': {
    garageId: 'finance',
    lotId: 'finance',
    vehicleName: 'FinanceHub',
    title: 'Finance',
    brickId: 'finance'
  },
  '/finance/reconciliation': {
    garageId: 'finance',
    lotId: 'invoices',
    vehicleName: 'InvoiceDashboard',
    title: 'Invoice, Reconciliation',
    brickId: 'finance'
  },
  '/finance/disbursements': {
    garageId: 'finance',
    lotId: 'disbursements',
    vehicleName: 'DisbursementsWithTabs',
    title: 'Disbursements',
    brickId: 'disbursements'
  },
  '/finance/drawer-cash': {
    garageId: 'finance',
    lotId: 'disbursements',
    vehicleName: 'DisbursementsWithTabs',
    title: 'Drawer, Cash',
    brickId: 'disbursements'
  },
  '/finance/group-billing': {
    garageId: 'finance',
    lotId: 'invoices',
    vehicleName: 'GroupBillingDashboard',
    title: 'Group, Billing',
    brickId: 'finance'
  },
  '/finance/payroll': {
    garageId: 'finance',
    lotId: 'disbursements',
    vehicleName: 'DisbursementsWithTabs',
    title: 'Disbursements',
    brickId: 'disbursements'
  },
  '/disbursements': {
    garageId: 'finance',
    lotId: 'disbursements',
    vehicleName: 'DisbursementsWithTabs',
    title: 'Disbursements',
    brickId: 'disbursements'
  },
  '/finance/disbursements-lot': {
    garageId: 'finance',
    lotId: 'disbursements',
    vehicleName: 'DisbursementsLot',
    title: 'Disbursements Lot',
    brickId: 'disbursements'
  },
  '/finance/pay-issues': {
    garageId: 'finance',
    lotId: 'disbursements',
    vehicleName: 'PayIssuesTab',
    title: 'Pay Issues',
    brickId: 'disbursements'
  },
  // Operations - Incidents
  '/operations/incidents': {
    garageId: 'operations',
    lotId: 'incidents',
    vehicleName: 'IncidentReportsCenter',
    title: 'Incident Reports',
    brickId: 'incidents'
  },
  '/incidents': {
    garageId: 'operations',
    lotId: 'incidents',
    vehicleName: 'IncidentReportsCenter',
    title: 'Incident Reports',
    brickId: 'incidents'
  },
  // Admin - Claims (moved from operations)
  '/admin/claims': {
    garageId: 'admin',
    lotId: 'claims',
    vehicleName: 'ClaimsCenter',
    title: 'Claims',
    brickId: 'claims'
  },
  '/claims': {
    garageId: 'admin',
    lotId: 'claims',
    vehicleName: 'ClaimsCenter',
    title: 'Claims',
    brickId: 'claims'
  },
  // Client Portal viewer — KOT/Council view into client portal
  '/clients/portal': {
    garageId: 'operations',
    lotId: 'portal',
    vehicleName: 'ClientPortalViewer',
    title: 'Client Portal',
    brickId: 'client-portal'
  },
  // Legacy AI accounting routes retained as compatibility paths
  // /finance/board was the Geoffrey board: its four panels fetched /api/agents/geoffrey/*, which
  // Vercel never served, under hardcoded "Running / 4/4 / 100%" status. Removed 2026-10-11; the
  // path lands on Bookkeeping (transaction coding), the live home of that work.
  '/finance/board': {
    garageId: 'finance',
    lotId: 'bookkeeping',
    vehicleName: 'BookkeepingLot',
    title: 'Books',
    brickId: 'finance'
  },
  '/finance/coaching': {
    garageId: 'finance',
    lotId: 'bookkeeping',
    vehicleName: 'BookkeepingLot',
    title: 'Books, AI Advisor',
    brickId: 'finance'
  },
  // Client domain
  '/clients': {
    garageId: 'operations',
    lotId: 'clients',
    title: 'Active, Clients',
    brickId: 'clients'
  },
  '/clients/contracts': {
    garageId: 'operations',
    lotId: 'contracts',
    title: 'Client, Contracts',
    brickId: 'contracts'
  },
  // '/clients/calm': {  // PARKED - moved to _parked folder
  //   garageId: 'clients',
  //   lotId: 'calm',
  //   title: 'CALM, Portal',
  //   brickId: 'calm'
  // },
  
  // Valet domain
  '/valets': {
    garageId: 'hr',
    lotId: 'valets',
    vehicleName: 'ValetManager',
    title: 'Valet, Roster',
    brickId: 'valets'
  },
  '/valets/whereabouts': {
    garageId: 'hr',
    lotId: 'valets',
    vehicleName: 'ValetWhereabouts',
    title: 'Valet, Whereabouts',
    brickId: 'valets'
  },
  '/hr/valets/reliability': {
    garageId: 'hr',
    lotId: 'valets',
    vehicleName: 'ReliabilityTab',
    title: 'Valet, Reliability',
    brickId: 'valets'
  },
  '/valets/reliability': {
    garageId: 'hr',
    lotId: 'valets',
    vehicleName: 'ReliabilityTab',
    title: 'Valet, Reliability',
    brickId: 'valets'
  },
  '/valets/badges': {
    garageId: 'hr',
    lotId: 'badges',
    title: 'Badges &, Achievements',
    brickId: 'badges'
  },
  '/valets/power-scores': {
    garageId: 'hr',
    lotId: 'power-score',
    title: 'Power, Scores',
    brickId: 'valets'
  },

  // Valet Garage (for badged valets)
  '/valet': {
    garageId: 'valet',
    lotId: 'dashboard',
    vehicleName: 'ValetDashboard',
    title: 'Valet, Dashboard',
    brickId: 'valets'
  },
  '/valet/leaderboard': {
    garageId: 'valet',
    lotId: 'leaderboard',
    vehicleName: 'ValetLeaderboard',
    title: 'Valet, Leaderboard',
    brickId: 'gamification'
  },

  // HR Ratings
  '/hr/ratings': {
    garageId: 'hr',
    lotId: 'ratings',
    vehicleName: 'ratings',
    title: 'HR, Ratings',
    brickId: 'ratings'
  },
    '/hr/recruitment': {
        garageId: 'hr',
        lotId: 'recruits',
        vehicleName: 'RecruitingLot',
        title: 'HR, Recruiting Pipeline',
        brickId: 'recruits'
    },
    '/hr/papercheck': {
        garageId: 'hr',
        lotId: 'recruits',
        vehicleName: 'PaperCheckDashboard',
        title: 'Paperwork, Check',
        brickId: 'recruits'
    },
    '/hr/licenses': {
        garageId: 'hr',
        lotId: 'licenses',
        vehicleName: 'LicensesGallery',
        title: 'HR, Licenses & MVRs',
        brickId: 'recruits'
    },
    '/hr/recruits': {
        garageId: 'hr',
        lotId: 'recruits',
        vehicleName: 'RecruitingLot',
        title: 'HR, Recruiting Pipeline',
        brickId: 'recruits'
    },
    '/recruiting': {
        garageId: 'hr',
        lotId: 'recruits',
        vehicleName: 'RecruitingLot',
        title: 'Recruiting Pipeline',
        brickId: 'recruits'
    },
    '/parkology': {
        garageId: 'hr',
        lotId: 'parkology',
        vehicleName: 'ParkologyDashboard',
        title: 'School of Parkology',
        brickId: 'certification'
    },
    '/parkology/academy': {
        garageId: 'hr',
        lotId: 'parkology',
        vehicleName: 'ParkologyAcademy',
        title: 'Parkology Academy',
        brickId: 'certification'
    },
    '/training': {
        garageId: 'hr',
        lotId: 'parkology',
        vehicleName: 'ParkologyDashboard',
        title: 'Training Academy',
        brickId: 'certification'
    },

  // Admin domain
  '/admin/platform': {
    garageId: 'admin',
    lotId: 'platform',
    title: 'Platform, Admin',
    brickId: 'platform-admin'
  },
  '/admin/users': {
    garageId: 'admin',
    lotId: 'users',
    title: 'User, Management',
    brickId: 'users'
  },
  '/admin/tasks': {
    garageId: 'admin',
    lotId: 'tasks',
    vehicleName: 'TaskBucket',
    title: 'Task Bucket',
    brickId: 'task-bucket'
  },
  '/admin/agents': {
    garageId: 'admin',
    lotId: 'agency',
    title: 'AI, Agents',
    brickId: 'ai-agents'
  },
  '/admin/contracts': {
    garageId: 'admin',
    lotId: 'contracts',
    vehicleName: 'index',
    title: 'Contracts',
    brickId: 'contracts'
  },
  '/admin/contracts/builder': {
    garageId: 'admin',
    lotId: 'contracts',
    vehicleName: 'ServiceAgreementBuilder',
    title: 'Service Agreement Builder',
    brickId: 'contracts'
  },
  '/admin/contracts/status': {
    garageId: 'admin',
    lotId: 'contracts',
    vehicleName: 'ContractStatusDashboard',
    title: 'Contract Signing Status',
    brickId: 'contracts'
  },
  '/admin/meetings': {
    garageId: 'admin',
    lotId: 'meetings',
    vehicleName: 'MeetingsLot',
    title: 'Meetings',
    brickId: 'admin'
  },
  '/leadership': {
    garageId: 'leadership',
    lotId: 'leadership',
    vehicleName: 'LeadershipManagement',
    title: 'ODV Leadership',
    brickId: 'clients'
  },
  // Compatibility route for old Admin bookmarks. Leadership owns its lot.
  '/admin/leadership': {
    garageId: 'leadership',
    lotId: 'leadership',
    vehicleName: 'LeadershipManagement',
    title: 'ODV Leadership',
    brickId: 'clients'
  },
  '/admin/matrix': {
    garageId: 'admin',
    lotId: 'wisdom-capture',
    vehicleName: 'ODVMatrix',
    title: 'ODV Matrix',
    brickId: 'admin'
  },
  // Quality Control — pop-in inspections and location health
  '/qc': {
    garageId: 'qc',
    lotId: 'qc',
    vehicleName: 'QCDashboard',
    title: 'Quality Control',
    brickId: 'evaluation'
  },
  // Communications — unified calls + SMS timeline with AI actions
  '/comms': {
    garageId: 'comms-center',
    lotId: 'comms',
    vehicleName: 'CommsDashboard',
    title: 'Communications',
    brickId: 'comms'
  },
  '/phone': {
    garageId: 'comms-center',
    lotId: 'phone',
    vehicleName: 'PhoneLot',
    title: 'Phone',
    brickId: 'phone'
  },
  '/sms': {
    garageId: 'comms-center',
    lotId: 'comms',
    vehicleName: 'SMSCenter',
    title: 'SMS Center',
    brickId: 'comms'
  },
  '/phone/analytics': {
    garageId: 'comms-center',
    lotId: 'phone',
    vehicleName: 'CallAnalyticsDashboard',
    title: 'Call Transcripts',
    brickId: 'phone'
  },
  // Mail Room — standalone AI-powered email command center
  '/mailroom': {
    garageId: 'mailroom',
    lotId: 'mailroom',
    vehicleName: 'Mailroom',
    title: 'Mail Room',
    brickId: 'mailroom'
  },
  // Legacy route — same MailroomLot UI at old path
  '/admin/mailroom': {
    garageId: 'admin',
    lotId: 'admin',
    vehicleName: 'MailroomLot',
    title: 'Mail Room',
    brickId: 'admin'
  },
  // Agents garage — proposals + learnings tabs inside one dashboard
  '/agents': {
    garageId: 'agents',
    lotId: 'index',
    vehicleName: 'AgentCommandCenter',
    title: 'Agents',
    brickId: 'ai-agents'
  },
  '/agents/voice-analytics': {
    garageId: 'agents',
    lotId: 'voice-analytics',
    vehicleName: 'VoiceAnalyticsDashboard',
    title: 'Voice Analytics',
    brickId: 'ai-agents'
  },
  // Legacy paths
  '/admin/agent-council': {
    garageId: 'agents',
    lotId: 'index',
    vehicleName: 'AgentCommandCenter',
    title: 'Agents',
    brickId: 'ai-agents'
  },
  '/admin/command-center': {
    garageId: 'agents',
    lotId: 'index',
    vehicleName: 'AgentCommandCenter',
    title: 'Agents',
    brickId: 'ai-agents'
  },
  // REMOVED: /admin/client-portal/* routes - Use /portal/* instead (public client portal)

  // Intel domain
  '/intel/court-vision': {
    garageId: 'agency',
    lotId: 'court-vision',
    vehicleName: 'CourtVisionSimple',
    title: 'Court Vision',
    brickId: 'assignments'
  },
  // '/intel/analytics': {  // PARKED - moved to _parked folder
  //   garageId: 'agency',
  //   lotId: 'analytics',
  //   title: 'Analytics',
  //   brickId: 'analytics'
  // },
  '/intel/reports': {
    garageId: 'agency',
    lotId: 'reports',
    title: 'Reports',
    brickId: 'reporting'
  },
  '/intel/leaderboards': {
    garageId: 'agency',
    lotId: 'leaderboards',
    title: 'Leaderboards',
    brickId: 'leaderboards'
  },

  // Branding domain
  // Apparel Admin (council/KOT face): Issued · Owing · Stock.
  // Valets shop at /valet/apparel (garages.js → ApparelStore, the legacy dashboard).
  '/branding': {
    garageId: 'branding',
    lotId: 'apparel',
    vehicleName: 'ApparelAdmin',
    title: 'Apparel Admin',
    brickId: 'branding'
  },
  '/branding/apparel': {
    garageId: 'branding',
    lotId: 'apparel',
    vehicleName: 'ApparelAdmin',
    title: 'Apparel Admin',
    brickId: 'branding'
  },

  // Marketing (formerly CRM) — /marketing is primary; the rest are legacy aliases
  '/crm': {
    garageId: 'hr',
    lotId: 'crm',
    vehicleName: 'index',
    title: 'Marketing',
    brickId: 'crm'
  },

  // Legacy routes → Marketing
  '/lead-engine': {
    garageId: 'hr',
    lotId: 'crm',
    vehicleName: 'index',
    title: 'Marketing',
    brickId: 'crm'
  },
  '/marketing': {
    garageId: 'hr',
    lotId: 'crm',
    vehicleName: 'index',
    title: 'Marketing',
    brickId: 'crm'
  },
  '/marketing/masterlist': {
    garageId: 'hr',
    lotId: 'crm',
    vehicleName: 'index',
    title: 'Marketing',
    brickId: 'crm'
  },
  '/leads': {
    garageId: 'hr',
    lotId: 'crm',
    vehicleName: 'index',
    title: 'Marketing',
    brickId: 'crm'
  },
  '/branding/crm': {
    garageId: 'hr',
    lotId: 'crm',
    vehicleName: 'index',
    title: 'Marketing',
    brickId: 'crm'
  },

  // Partners domain
  '/partners': {
    garageId: 'partners',
    lotId: 'index',
    vehicleName: 'PartnersLot',
    title: 'Partners',
    brickId: 'partners'
  },
  '/partners/4u': {
    garageId: 'partners',
    lotId: 'index',
    vehicleName: 'PartnersLot',
    title: '4u Valet — Partnership',
    brickId: 'partners'
  },

  // Note: /demo/gamification is handled as a direct route in App.jsx (bypasses ParkingLot)
};

// Helper to get route info from path
export function getRouteInfo(path) {
  // First try exact match in BUSINESS_ROUTES
  if (BUSINESS_ROUTES[path]) {
    return BUSINESS_ROUTES[path];
  }

  // Try to match dynamic routes with :id parameters
  // Check all routes with :id pattern
  for (const [routePath, routeInfo] of Object.entries(BUSINESS_ROUTES)) {
    if (routePath.includes(':')) {
      // Convert route patterns such as /finance/invoices/:id to a single-segment matcher.
      const pattern = routePath.replace(/:[\w]+/g, '[^/]+');
      const regex = new RegExp(`^${pattern}$`);
      if (regex.test(path)) {
        return routeInfo;
      }
    }
  }

  // REMOVED: /admin/client-portal/* handling - Use /portal/* instead (public client portal)

  // If no exact match, try to parse as dynamic route /:garageId/:lotId
  const match = path.match(/^\/([a-z-]+)\/([a-z-]+)$/);
  if (match) {
    const [, garageId, lotId] = match;

    // Look up garage and lot from GARAGES config
    const garage = GARAGES.find(g => g.id === garageId);
    const lot = garage?.lots?.find(l => l.id === lotId);

    if (garage && lot) {
      return {
        garageId,
        lotId,
        title: `${garage.name}, ${lot.name}`,
        brickId: lot.id,
        vehicleName: lot.component || null
      };
    }
  }

  return null;
}

// Helper to get all routes for a garage
export function getGarageRoutes(garageId) {
  return Object.entries(BUSINESS_ROUTES)
    .filter(([, route]) => route.garageId === garageId)
    .map(([path, route]) => ({ path, ...route }));
}

// Helper to build a business route
export function buildRoute(domain, feature) {
  return `/${domain}${feature ? `/${feature}` : ''}`;
}
